import { Icon } from '@lbcamden/lib-react';
import { FunctionComponent, PropsWithChildren, useState } from 'react';

import { ShowDetailsContent, ShowDetailsRoot, ShowDetailsTrigger } from './ShowDetails.styled';

type Props = PropsWithChildren<{
  label: (open: boolean) => string;
  className?: string;
}>;

export const ShowDetails: FunctionComponent<Props> = ({ label, children, ...props }) => {
  const [open, setOpen] = useState(false);
  return (
    <ShowDetailsRoot {...props} open={open} onOpenChange={setOpen}>
      <ShowDetailsTrigger>
        <span>{label(open)}</span>
        <Icon icon="ui/chevron" />
      </ShowDetailsTrigger>

      <ShowDetailsContent>{children}</ShowDetailsContent>
    </ShowDetailsRoot>
  );
};
